import {ChangeEvent, useCallback, useState} from 'react';
import {formatAutoCleanPhoneNumber, parseUSPhoneNumber} from '~/common/utils';
import {Input} from '~library/atoms/Input';

type RSVPModalVariantABContentProps = {
  onChange: (phone: string) => void;
  className?: string;
  value: string;
  disabled?: boolean;
};

export const PhoneInput = ({
  value,
  onChange,
  className,
  disabled,
}: RSVPModalVariantABContentProps) => {
  const [errorMessage, setErrorMessage] = useState('');

  const onChangeHandler = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      if (parseUSPhoneNumber(e.target.value).is_valid) {
        setErrorMessage('');
      }
      onChange(formatAutoCleanPhoneNumber(e.target.value));
    },
    [onChange]
  );

  const onBlurHandler = useCallback(() => {
    if (!value) {
      setErrorMessage('');
    } else if (!parseUSPhoneNumber(value).is_valid) {
      setErrorMessage('Invalid phone number');
    }
  }, [value]);

  return (
    <Input
      className={className}
      data-qa-id="sign-up-overlay-your-phone"
      type="tel"
      label="Phone Number"
      value={formatAutoCleanPhoneNumber(value.replace(/^\+1/, ''))}
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
      error={errorMessage}
      placeholder="(XXX) XXX-XXXX"
      disabled={disabled}
    />
  );
};
